var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-footer" },
    [
      _c(
        "div",
        { staticClass: "left" },
        [
          _c("div", { staticClass: "record-count" }, [
            _vm._v(
              _vm._s(_vm.$t("tables.recordCount")) +
                ": " +
                _vm._s(_vm.recordCount)
            ),
          ]),
          _vm._v(" "),
          false
            ? _c(
                "SupsisButton",
                {
                  staticClass: "increase-limit-btn",
                  attrs: { disabled: true },
                  on: { click: _vm.increaseLimit },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("tables.increaseLimit")) + "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "PermissionController",
            { attrs: { permissions: ["table.update"] } },
            [
              _vm.isRecordLimitExceeded
                ? _c(
                    "a-tooltip",
                    { attrs: { placement: "top" } },
                    [
                      _c("template", { slot: "title" }, [
                        _vm._v(
                          "\n                    Kayıt limiti doldu. Yeni kayıt eklemek için plan yükseltmeniz gerekiyor.\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-badge",
                        {
                          attrs: {
                            count: _vm.isRecordLimitExceeded ? "!" : 0,
                            "number-style": { backgroundColor: "#ff4d4f" },
                          },
                        },
                        [
                          _vm.canCreateRecord
                            ? _c(
                                "SupsisButton",
                                {
                                  staticClass: "new-record-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$feature.beforeCreateTableRecord(
                                        _vm.createNewRecord,
                                        _vm.recordCount
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("add_box"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("tables.newRecord")) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isRecordLimitExceeded && _vm.canCreateRecord
                ? _c(
                    "SupsisButton",
                    {
                      staticClass: "new-record-btn",
                      on: {
                        click: function ($event) {
                          return _vm.$feature.beforeCreateTableRecord(
                            _vm.createNewRecord,
                            _vm.recordCount
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add_box"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("tables.newRecord")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "PermissionController",
            { attrs: { permissions: ["table.update"] } },
            [
              _vm.isRecordLimitExceeded
                ? _c(
                    "a-tooltip",
                    { attrs: { placement: "top" } },
                    [
                      _c("template", { slot: "title" }, [
                        _vm._v(
                          "\n                    Kayıt limiti doldu. Kayıt içeri aktarmak için plan yükseltmeniz gerekiyor.\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-badge",
                        {
                          attrs: {
                            count: _vm.isRecordLimitExceeded ? "!" : 0,
                            "number-style": { backgroundColor: "#ff4d4f" },
                          },
                        },
                        [
                          _vm.canImportRecords
                            ? _c(
                                "SupsisButton",
                                {
                                  staticClass: "import-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.$feature.beforeCreateTableRecord(
                                        _vm.importRecords,
                                        _vm.recordCount
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("cloud_upload"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("tables.imports")) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isRecordLimitExceeded && _vm.canImportRecords
                ? _c(
                    "SupsisButton",
                    {
                      staticClass: "import-btn",
                      on: {
                        click: function ($event) {
                          return _vm.$feature.beforeCreateTableRecord(
                            _vm.importRecords,
                            _vm.recordCount
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("cloud_upload"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("tables.imports")) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.canExportRecords
            ? _c(
                "a-popover",
                { attrs: { trigger: "click", placement: "topLeft" } },
                [
                  _c("template", { slot: "content" }, [
                    _c("div", { staticClass: "action-menu" }, [
                      _c(
                        "div",
                        {
                          staticClass: "action-item",
                          class: { disabled: !_vm.hasSelection },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.hasSelection && _vm.exportSelectedRecords()
                            },
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: { color: "#52c41a" },
                            },
                            [_vm._v("check_box")]
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.hasSelection
                                  ? "Seçilenleri İndir (" +
                                      _vm.selectedRecordsCount +
                                      ")"
                                  : "Seçilenleri İndir"
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "action-item",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openExport("page")
                            },
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: { color: "#faad14" },
                            },
                            [_vm._v("file_download")]
                          ),
                          _vm._v(
                            "\n                        Bu Sayfayı İndir\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "action-item",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openExport("all")
                            },
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: { color: "#faad14" },
                            },
                            [_vm._v("cloud_download")]
                          ),
                          _vm._v(
                            "\n                        Tümünü İndir\n                    "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("SupsisButton", { staticClass: "export-btn" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("cloud_download"),
                    ]),
                    _vm._v(
                      " " + _vm._s(_vm.$t("tables.exports")) + "\n            "
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              staticClass: "ai-assistant-btn",
              on: { click: _vm.showFieldWizard },
            },
            [
              _c("img", {
                staticStyle: { "margin-right": "5px" },
                attrs: {
                  src: "/static/img/copilot.png",
                  width: "15",
                  height: "15",
                },
              }),
              _vm._v("\n            Supsis Asistan\n        "),
            ]
          ),
          _vm._v(" "),
          false
            ? _c(
                "SupsisButton",
                {
                  staticClass: "download-btn",
                  attrs: { disabled: true },
                  on: { click: _vm.downloadRecords },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("get_app"),
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("tables.download")) + "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          _vm.recordCount > _vm.cursor.perPage
            ? _c("a-pagination", {
                attrs: {
                  current: _vm.cursor.page,
                  total: _vm.recordCount,
                  pageSize: _vm.cursor.perPage,
                  "show-size-changer": "",
                  "show-quick-jumper": "",
                  pageSizeOptions: ["100", "250", "500", "750", "1000"],
                  size: "small",
                },
                on: {
                  change: _vm.onPageChange,
                  showSizeChange: _vm.onShowSizeChange,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "PermissionController",
            { attrs: { permissions: ["automation.get"] } },
            [
              _c(
                "a-popover",
                { attrs: { trigger: "click", placement: "topRight" } },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "automation-popover custom-automation-popover",
                      },
                      [
                        _c(
                          "PermissionController",
                          { attrs: { permissions: ["automation.create"] } },
                          [
                            _c("div", { staticClass: "group" }, [
                              _c("div", { staticClass: "group-title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("ticimax.createAutomation"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "group-item event",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showCreateAutomationModal(
                                        "table.record_created"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("add"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("tables.recordCreated")) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "group-item event",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showCreateAutomationModal(
                                        "table.record_updated"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("update"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("tables.recordUpdated")) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "group-item event",
                                  on: {
                                    click: function ($event) {
                                      return _vm.showCreateAutomationModal(
                                        "table.record_deleted"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("delete"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("tables.recordDeleted")) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "group" },
                          [
                            _c("div", { staticClass: "group-title" }, [
                              _vm._v(_vm._s(_vm.$t("automation.automations"))),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.tableAutomations, function (automation) {
                              return _c(
                                "div",
                                {
                                  key: automation._id,
                                  staticClass: "group-item automation",
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToAutomation(automation._id)
                                    },
                                  },
                                },
                                [
                                  _c("AutomationIcon", {
                                    tag: "component",
                                    staticClass: "myIcon",
                                  }),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(automation.name) +
                                      "\n                            "
                                  ),
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            !_vm.tableAutomations.length
                              ? _c("div", { staticClass: "no-automation" }, [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("info"),
                                  ]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("tables.noAutomationDefined")
                                      ) +
                                      "\n                            "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    { staticClass: "automate-btn", attrs: { type: "primary" } },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("settings_applications"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("tables.automateYourData")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.$t("ticimax.createAutomation") },
          on: { ok: _vm.createAutomation },
          model: {
            value: _vm.createAutomationModalVisible,
            callback: function ($$v) {
              _vm.createAutomationModalVisible = $$v
            },
            expression: "createAutomationModalVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "automation-name-input" },
            [
              _c(
                "div",
                { staticClass: "description" },
                [
                  _vm.selectedAutomationEvent === "table.record_created"
                    ? [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("tables.nameTheAutomationAdd")) +
                            "\n                "
                        ),
                      ]
                    : _vm.selectedAutomationEvent === "table.record_updated"
                    ? [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("tables.nameTheAutomationUpdate")) +
                            "\n                "
                        ),
                      ]
                    : _vm.selectedAutomationEvent === "table.record_deleted"
                    ? [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("tables.nameTheAutomationDelete")) +
                            "\n                "
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c("a-input", {
                attrs: { placeholder: _vm.$t("automation.automationName") },
                model: {
                  value: _vm.automationName,
                  callback: function ($$v) {
                    _vm.automationName = $$v
                  },
                  expression: "automationName",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showTableAiAgent
        ? _c("TableAiAgent", {
            attrs: { tableId: _vm.tableId },
            on: {
              "field-added": _vm.onFieldAdded,
              "field-updated": _vm.onFieldUpdated,
              "field-deleted": _vm.onFieldDeleted,
              "filters-updated": _vm.onFiltersUpdated,
              "group-updated": _vm.onGroupUpdated,
              "hidden-fields-updated": _vm.onHiddenFieldsUpdated,
              "color-conditions-updated": _vm.onColorConditionsUpdated,
              "multi-record-created": _vm.onMultiRecordCreated,
              close: function ($event) {
                _vm.showTableAiAgent = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showExportSettings
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("Kayıtları İndir - Ayarlar"),
                className: "export-settings-modal keydown-prevent-modal",
                showFooter: false,
                xlarge: "",
              },
              on: { cancel: _vm.closeExportSettings },
            },
            [
              _c("ExportSettings", {
                attrs: { fields: _vm.fields, records: _vm.records },
                on: {
                  start: _vm.onExportSettingsStart,
                  cancel: _vm.closeExportSettings,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }